import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/img-change-default-pwd.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "img-change-default-pwd",
  width: "328"
}, null, -1)
const _hoisted_2 = { class: "form-container" }
const _hoisted_3 = { class: "form-hd" }
const _hoisted_4 = { class: "title-pwd" }
const _hoisted_5 = { class: "tip default-pwd-tip" }
const _hoisted_6 = { class: "skip-wrap" }


import { changePassword } from '@/api/function'
import { defineComponent, reactive, ref, defineEmits } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

const __default__ = defineComponent({
  name: 'ResetPassword',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  emits: ["login"],
  setup(__props, { emit: emits }: { emit: ({ (e: 'login', payload: { username: string; password: string }): void }), expose: any, slots: any, attrs: any }) {

const route = useRoute()
const router = useRouter()
const store = useStore()
const { t } = useI18n()



const PwdFormCom = ref()
const isSubmitting = ref(false)
const record = reactive({
  username: '',
  password: '',
})
const newPasswordRecord = reactive({
  password: '',
  passwordRepeat: '',
})
const redirectToDashboard = () => {
  router.replace({
    path: (route.query.to ?? '/home').toString(),
  })
}

const submitNewPwd = async () => {
  try {
    await PwdFormCom.value.validate()
    isSubmitting.value = true
    const { username, password: old_pwd } = record
    const { password: new_pwd } = newPasswordRecord
    await changePassword(username, { new_pwd, old_pwd })
    store.commit('UPDATE_USER_INFO', { logOut: true })
    emits('login', { username, password: new_pwd })
  } catch (error) {
    //
  } finally {
    isSubmitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createBlock(_component_el_row, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_col, {
        span: 12,
        class: "img-container"
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_el_col, {
        span: 12,
        class: "col-new-pwd"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('General.changePassword')), 1),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('Base.defaultPwdTip')), 1),
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('General.passwordRequirement1')), 1),
                  _createElementVNode("li", null, _toDisplayString(_ctx.$t('General.passwordRequirement2')), 1)
                ])
              ])
            ]),
            _createVNode(_component_el_form, {
              ref_key: "PwdFormCom",
              ref: PwdFormCom,
              "hide-required-asterisk": "",
              size: "large",
              class: "password-form",
              model: _unref(newPasswordRecord),
              rules: _ctx.pwdRules,
              onKeyup: _withKeys(submitNewPwd, ["enter"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { prop: "password" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(newPasswordRecord).password,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(newPasswordRecord).password) = $event)),
                      modelModifiers: { trim: true },
                      autofocus: "",
                      "show-password": "",
                      tabindex: "1",
                      type: "password",
                      placeholder: _unref(t)('General.newPassword')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, { prop: "passwordRepeat" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(newPasswordRecord).passwordRepeat,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(newPasswordRecord).passwordRepeat) = $event)),
                      "show-password": "",
                      tabindex: "2",
                      type: "password",
                      placeholder: _unref(t)('General.confirmPassword')
                    }, null, 8, ["modelValue", "placeholder"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "btn-submit",
                  type: "primary",
                  onClick: submitNewPwd,
                  loading: isSubmitting.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Base.confirm')), 1)
                  ]),
                  _: 1
                }, 8, ["loading"]),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: _ctx.$t('Base.skipTip')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        class: "btn-skip",
                        type: "primary",
                        link: "",
                        onClick: redirectToDashboard
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('Base.skip')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ]),
              _: 1
            }, 8, ["model", "rules", "onKeyup"])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})